module.exports = __webpack_public_path__ + "static/img/AC4136503.b986dea1.jpg";